// SEO-Helper: Setzt dynamisch Title, Meta-Description, Canonical, OG-Tags und JSON-LD.
// Für eine CRA-SPA die pragmatische Lösung; Pre-Rendering ergänzt statisches HTML.

const BASE_URL = 'https://domain-preischeck.de';
const SITE_NAME = 'Domain-Preisvergleich.de';

function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setProperty(prop, content) {
  let el = document.querySelector(`meta[property="${prop}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', prop);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(path) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', `${BASE_URL}${path}`);
}

function setJsonLd(data) {
  const items = Array.isArray(data) ? data : [data];
  document.querySelectorAll('script[id^="jsonld-seo"]').forEach(el => el.remove());
  items.forEach((item, i) => {
    const el = document.createElement('script');
    el.id = `jsonld-seo-${i}`;
    el.type = 'application/ld+json';
    el.textContent = JSON.stringify(item);
    document.head.appendChild(el);
  });
}

export function applySeo({ title, description, path, type = 'website', jsonLd = null }) {
  document.title = title;
  setMeta('description', description);
  setCanonical(path || '/');
  setProperty('og:title', title);
  setProperty('og:description', description);
  setProperty('og:type', type);
  setProperty('og:url', `${BASE_URL}${path || '/'}`);
  setProperty('og:site_name', SITE_NAME);
  setProperty('og:locale', 'de_DE');
  setProperty('og:image', `${BASE_URL}/og-image.svg`);
  if (jsonLd) setJsonLd(jsonLd);
}

// Spezifische JSON-LD-Bausteine
export function websiteJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: BASE_URL,
    description: 'Der faire Domain-Preisvergleich: Registrierung, Verlängerung und Transfer bei allen großen Anbietern im Vergleich.',
    potentialAction: {
      '@type': 'SearchAction',
      target: { '@type': 'EntryPoint', urlTemplate: `${BASE_URL}/tld/{search_term_string}` },
      'query-input': 'required name=search_term_string',
    },
  };
}

export function breadcrumbJsonLd(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.name,
      item: `${BASE_URL}${item.path}`,
    })),
  };
}

export function tldProductJsonLd(tld, results) {
  const offers = (results || [])
    .filter(r => r.calculation?.total > 0)
    .slice(0, 20)
    .map(r => ({
      '@type': 'Offer',
      priceCurrency: 'EUR',
      price: r.calculation.total,
      itemCondition: 'https://schema.org/NewCondition',
      availability: 'https://schema.org/InStock',
      seller: { '@type': 'Organization', name: r.provider_name },
    }));
  if (offers.length === 0) return null;
  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: `${tld} Domain registrieren`,
    description: `Vergleichen Sie ${tld}-Domain-Preise aller großen Anbieter – Registrierung, Verlängerung und Transfer.`,
    offers,
  };
}
